import React from 'react'
import {
  Route,
} from 'react-router'

/** Route pages */
import Populator from 'populators/Impersonate'

const Impersonate = (store) => {
  const Routes = () => (
    <Route
      path="impersonate/:profileId/:profileSlug"
      component={Populator.components.Loading}
      onEnter={next =>
        Populator.populate.impersonate(store, next.params.profileId, next.params.profileSlug)
      }
    />
  )

  return Routes()
}

export default Impersonate
